import { toHyphenatedSlug } from './faqSlugFromVenueName'

export const LOCATION_SECTION_KEY_SEPARATOR = '-'

export const buildLocationSectionKey = (levelKey, sectionLabelOrKey) => {
  const normalizedLevelKey = String(levelKey ?? '').trim()
  const sectionSlug = toHyphenatedSlug(sectionLabelOrKey)

  if (!sectionSlug) {
    return ''
  }

  if (!normalizedLevelKey) {
    return sectionSlug
  }

  const prefix = `${normalizedLevelKey}${LOCATION_SECTION_KEY_SEPARATOR}`
  if (sectionSlug.startsWith(prefix)) {
    return sectionSlug
  }

  return `${prefix}${sectionSlug}`
}

export const normalizeLocationSubsectionKeys = (sections = [], levelKey) =>
  (Array.isArray(sections) ? sections : []).map(section => ({
    ...section,
    key: buildLocationSectionKey(levelKey, section.label ?? section.key)
  }))
